interface AnimationConfig {
    animationDuration: number;
    animationEasing: 'ease' | 'ease-in' | 'ease-out' | 'ease-in-out' | 'linear';
    animationBegin: number;
}

export const CHART_ANIMATION_CONFIG: AnimationConfig = {
    animationDuration: 600,
    animationEasing: 'ease-out',
    animationBegin: 200,
};

export const DEFAULT_FILL_TRANSITION = 'fill 0.1s ease-in-out';
